import { sessionStorageHelper } from '../../../helpers/storage/index.js';
import { config } from '../../../config.js';

import type { Vendor } from '../../../types';

const productType = 'ResponsiveWeb';

export const getPulseProvider = (vendor: Vendor) => {
  if (config.provider === 'ab') {
    return {
      product: 'aftonbladet',
      productType,
      'spt:engage': 'AB',
    };
  }

  const isPwa = sessionStorageHelper.getItem('isPwa');

  return {
    productTag:
      vendor === 'brandstudio' ? 'partnerstudio' : config.pulse.productTag,
    productType: isPwa === 'true' ? 'PWA' : productType,
  };
};
